import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get, isNil } from 'lodash';
import moment from 'moment-timezone';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Grid, Box } from '@material-ui/core';
import Document from 'components/Document';
import messages from 'containers/LawyerFeeNote/messages';
import { translate } from 'containers/services/translate';
import { handleOpenDocument } from 'services/utils';
import { DATE_FORMAT, DOCUMENT_TYPES } from 'constants/global';

export interface InvoiceFeeNoteRecapProps {
  intl: IntlShape;
  InvoiceInfo: any;
  requestGetDocByDocumentumId: Function;
}

export const InvoiceFeeNoteRecap: React.FC<InvoiceFeeNoteRecapProps> = (
  props,
): JSX.Element => {
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <Box bgcolor="white" className="cheque-fields-box">
            <Grid container direction="column">
              <Grid item>
                <span className="title-check-fields">
                  {translate(messages.invoiceDate, props)}
                </span>
              </Grid>
              <Grid item>
                <span>
                  {!isNil(get(props.InvoiceInfo, 'invoiceDate', null))
                    ? moment(get(props.InvoiceInfo, 'invoiceDate')).format(
                        DATE_FORMAT,
                      )
                    : '-'}
                </span>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={3}>
          <Box bgcolor="white" className="cheque-fields-box">
            <Grid item>
              <span className="title-check-fields">
                {translate(messages.invoiceNumber, props)}
              </span>
            </Grid>
            <Grid item>
              <span>
                {!isNil(get(props.InvoiceInfo, 'invoiceNumber', null))
                  ? get(props.InvoiceInfo, 'invoiceNumber')
                  : '-'}
              </span>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Box bgcolor="white" className="cheque-fields-box">
            <Grid item>
              <span className="title-check-fields">
                {translate(messages.receptionDate, props)}
              </span>
            </Grid>
            <Grid item>
              <span>
                {!isNil(get(props.InvoiceInfo, 'receptionDate', null))
                  ? moment(get(props.InvoiceInfo, 'receptionDate')).format(
                      DATE_FORMAT,
                    )
                  : '-'}
              </span>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      {!isNil(get(props.InvoiceInfo, 'url', null)) && (
        <div className="doc-container">
          <div className="title">
            {translate(messages.invoiceDocumentTitle, props)}
          </div>
          <Document
            name={get(props.InvoiceInfo, 'name', '')}
            type={DOCUMENT_TYPES.INVOICE_DOCUMENT}
            icon={
              <VisibilityIcon
                className="consult"
                onClick={handleOpenDocument(
                  props.InvoiceInfo,
                  props.requestGetDocByDocumentumId,
                )}
              />
            }
          />
        </div>
      )}
    </div>
  );
};

export default injectIntl(InvoiceFeeNoteRecap);
